<template>
  <v-card>
    <v-toolbar dense card class="tb">
      <v-toolbar-title class="title body-2">{{ title }} <span v-if="showCounter">({{ counter }})</span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="showActionIcon"
        icon
        :loading="loading"
        @click="$emit('refreshCard')"
      ><v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-0 cardscroll">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DashboardCard',
  props: {
    title: {
      type: String,
      default: 'My Title'
    },
    counter: {
      type: String,
      default: ''
    },
    showCounter: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    showActionIcon: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.cardscroll {
  height: 21rem;
  overflow-y: auto;
}
.tb > :first-child {
  padding-left: 16px;
}
</style>